export const WORK_ORDERS_REQUEST = "WORK_ORDERS_REQUEST";
export const WORK_ORDERS_SUCCESS = "WORK_ORDERS_SUCCESS";
export const WORK_ORDERS_ERROR = "WORK_ORDERS_ERROR";

export const WORKORDER_UPDATE_REQUEST = "WORKORDER_UPDATE_REQUEST";
export const WORKORDER_UPDATE_SUCCESS = "WORKORDER_UPDATE_SUCCESS";
export const WORKORDER_UPDATE_ERROR = "WORKORDER_UPDATE_ERROR";
